import { toI18n } from 'util/i18n';

export const OPEN_SHIFT_OPTION = 'open';
export const TAB = {
  CUSTOM: 'custom',
  NOTES: 'notes',
  TIME_OFF: 'timeoff',
  COMMON: 'common',
  APPROVALS: 'approvals',
};

export const COMMON_SHIFT_VERSION = {
  INLINE: 'inline',
  TAB: 'tab',
};

export const ADD_SHIFT_TYPE = {
  COMMON: 'common',
  CUSTOM: 'custom',
};

export const ADD_SHIFT_TAB = {
  label: toI18n('schedule_builder.react_page.shift_form.add_shift'),
  value: TAB.CUSTOM,
};

export const CURRENT_TAB = {
  label: toI18n('schedule_builder.react_page.shift_form.current'),
  value: TAB.CUSTOM,
};

export const NOTES_TAB = {
  label: toI18n('schedule_builder.react_page.shift_form.notes'),
  value: TAB.NOTES,
};

export const APPROVALS_TAB = {
  label: toI18n('schedule_builder.react_page.shift_form.approvals'),
  value: TAB.APPROVALS,
};

export const TIME_OFF_TAB = {
  label: toI18n('schedule_builder.react_page.shift_form.time_off'),
  value: TAB.TIME_OFF,
};

export const AVAILABILITY_BLOCK_I18N =
  'schedule_builder.react_page.availability_block';

export const COMMON_SHIFT_RECOMMENDATION_RANKS = [
  'most_frequent',
  'second_most_frequent',
  'third_most_frequent',
];

export const COMMON_SHIFT_LEVELS = {
  user: 'user',
  role: 'role',
  location: 'location',
};

export const COMMON_SHIFT_DOW = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
];
